import { FilteredCongestionReportsParagraphProps } from 'components/CongestionReportsParagraph';
import { commaSeparatedStringFormatter } from 'src/utils/commaSeparatedStringFormatter';
import { exactDateFormatter, quarterDateFormatter } from 'src/utils/dateFormatter';
import { capitalizeLocationName } from 'src/utils';
import { FALLBACK_STATUS, FALLBACK_VALUE } from '../constant/constants';

type CongestionReport = FilteredCongestionReportsParagraphProps['congestionReport'];

export const getReplaceText = (congestionReport: CongestionReport): Record<string, string> => {
  return {
    '{location}': commaSeparatedStringFormatter(congestionReport?.locations) ?? FALLBACK_VALUE,
    '{name}': congestionReport?.name
      ? capitalizeLocationName(congestionReport?.name)
      : FALLBACK_VALUE,
    '{congestionType}': congestionReport?.congestionType
      ? congestionReport?.congestionType.toLowerCase()
      : FALLBACK_VALUE.toLowerCase(),
    '{status}': congestionReport?.status?.length
      ? congestionReport?.status.toLowerCase()
      : FALLBACK_STATUS.toLowerCase(),
    '{announcementExactDate}': exactDateFormatter(
      congestionReport?.announcementDate,
      FALLBACK_VALUE.toLowerCase()
    ),
    '{announcementQuarterDate}': quarterDateFormatter(
      congestionReport?.announcementDate,
      FALLBACK_VALUE.toLowerCase()
    ),
  };
};
